export const IATA_CODES_WITH_SKIP_PASSENGERS: string[] = ['DV'];

export function shouldSkipPassengers(passengersCount: number, iataCode: string): boolean {
	return passengersCount === 1 || IATA_CODES_WITH_SKIP_PASSENGERS.includes(iataCode);
}
